import { FC, createContext, useContext, useState } from "react";
export interface CartContextType {
  ingredientsToCart: any[];
  setIngredients: (ids: string[]) => void;
  toolsToCart: string[];
  setTools: (ids: string[]) => void;
  toolsPrice: string;
  setToolsPrice: (price: string) => void;
  mainProducts: any[];
  setMainProducts: (data: any) => void;
}

export const CartContext = createContext<CartContextType>(undefined);
export const CartProvider: FC = ({ children }) => {
  const [ingredientsToCart, setIngredientsToCart] = useState([]);
  const [toolsToCart, setToolsToCart] = useState([]);
  const [toolsPrice, setToolsPrice] = useState("");
  const [mainProducts, setProducts] = useState([]);
  const setIngredients = (ids: string[]) => setIngredientsToCart(ids);
  const setTools = (ids: string[]) => setToolsToCart(ids);
  const setMainProducts = (data) => setProducts(data);
  return (
    <CartContext.Provider
      value={{
        ingredientsToCart,
        setIngredients,
        toolsToCart,
        setTools,
        toolsPrice,
        setToolsPrice,
        mainProducts,
        setMainProducts,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
export const useRecipeCart = () => {
  const ctx = useContext(CartContext);

  if (!ctx) {
    throw new Error(
      "Shopify context must be used within a shopify context provider"
    );
  }

  return ctx;
};
